function stringToNumber(str) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i)
    hash |= 0 // Convert to 32bit integer
  }
  return hash
}

// function to generate a psuedo-random number given a seed value
// with Linear Congruential Generator algorithm
export function seededRandomizer(seed) {
  seed = typeof seed === 'string' ? stringToNumber(seed) : seed
  const m = 0x80000000 // 2^31
  const a = 1103515245
  const c = 12345

  return function randomGenerator() {
    seed = (a * seed + c) % m
    return seed / m
  }
}
